(ns css.form
  (:require
    [reagent.core :as r]
    [css.core :refer [get-theme defstyled]]
    [cljss.core :as cljss]
    [css.vars :as vars]
    [css.icons :as icon]
    [util.core :refer [to-input-date now]]))


(defstyled button-row-s :div
  {:display "grid"
   :grid-template-columns (with-meta #(or % "max-content max-content") :grid-template-columns)
   :align-items "center"
   :grid-column-gap "30px"
   :width "100%"
   :justify-content (with-meta #(or % "center") :justify)
   :margin (with-meta #(or % "5rem 0 0") :margin)
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "1fr"
                   :grid-row-gap "15px"}}})

(defstyled button :button
  {:background vars/black
   :border-style "none"
   :color "rgb(255,255,255)"
   :cursor "pointer"
   :display "flex"
   :justify-content "center"
   :align-items "center"
   :font-size (with-meta #(if (= % "large") "1.33rem" "1rem") :size)
   :min-height (with-meta #(if (= % "large") "4.25rem" "3rem") :size)
   :font-weight (with-meta #(if (= % "large") "300" "400") :size)
   :margin (with-meta #(or % "0") :margin)
   :min-width "9.5rem"
   :max-width (with-meta #(or % "100%") :max-width)
   :padding (with-meta #(if (= % "large") "0 3rem" "0 2rem") :size)
   :width (with-meta #(or % "auto") :width)
   :transition "background .25s ease-in"
   :&:hover {:background "black"}

   :&:focus {:outline (str "1px dotted " vars/black)
             :outline-offset "2px"}
   :&:disabled {:cursor "not-allowed"
                :opacity 0.6}
   ::cljss/media {[[:max-width "768px"]]
                  {:height "4rem"
                   :display "flex"
                   :align-items "center"
                   :justify-content "center"
                   :width "100%"
                   :grid-row (with-meta #(or % "1") :grid-row)}}})

(defstyled secondary-button-s :button
  {:background "white"
   :border "1px solid rgba(61,61,61)"
   :color "rgb(61,61,61)"
   :cursor "pointer"
   :display "flex"
   :justify-content "center"
   :align-items "center"
   :font-size (with-meta #(if (= % "large") "1.33rem" "1rem") :size)
   :min-height (with-meta #(if (= % "large") "4.25rem" "3rem") :size)
   :font-weight (with-meta #(if (= % "large") "300" "400") :size)
   :width (with-meta #(or % "auto") :width)
   :min-width "9.5rem"
   :padding (with-meta #(if (= % "large") "0 3rem" "0 2rem") :size)
   :transition "box-shadow .25s ease-in"
   :&:hover {:box-shadow (str "inset 0 0 0 1px " vars/black)}
   :&:focus {:outline (str "1px dotted " vars/black)
             :outline-offset "2px"}
   :&:disabled {:cursor "not-allowed"
                :opacity ".6"}
   ::cljss/media {[[:max-width "768px"]]
                  {:height "4rem"
                   :display "flex"
                   :align-items "center"
                   :justify-content "center"
                   :width "100%"
                   :grid-row "2"}}})

(defstyled naked-button-s :button
  {:background "none"
   :border "none"
   :color (with-meta #(or % (get-theme :primary)) :color)
   :display (with-meta #(or % "flex") :display)
   :align-items "center"
   :cursor "pointer"
   :font-size (with-meta #(or % "0.875rem") :font-size)
   :margin (with-meta #(or % "0") :margin)
   :padding (with-meta #(or % "0 0 2px") :padding)
   :border-bottom "1px solid transparent"
   :transition "border .25s ease-in"
   :&:hover {:border-bottom-color (get-theme :primary)}
   :&:focus {:outline (str "1px dotted " (get-theme :primary))
             :outline-offset "4px"}
   :&:disabled {:cursor "not-allowed"
                :opacity ".6"}})

(defstyled naked-button-symbol-s :div
  {:font-size (with-meta #(if (= % "small") "1rem" "20px") :size)
   :width (with-meta #(if (= % "small") "20px" "25px") :size)
   :height (with-meta #(if (= % "small") "20px" "25px") :size)
   :display "flex"
   :align-items "center"
   :justify-content "center"
   :font-family "monospace"
   :border (str "1px solid " (get-theme :primary))
   :border-radius "100%"
   :margin (with-meta #(if (= % "small") "0 8px 0 0" "0 10px 2px 0") :size)
   :padding (with-meta #(if (= % "small") "3px" "5px") :size)})

(defstyled remove-button :button
  {:background-color "inherit"
   :background-image "url(/assets/icons/close.svg)"
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :border "none"
   :cursor "pointer"
   :padding "0 7px"
   :margin-left "-14px"
   :&:focus {:outline (str "1px dotted " (get-theme :primary))
             :outline-offset "4px"}
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-row "1"
                   :grid-column "2"
                   :background-size "20px"
                   :justify-self "flex-end"
                   :width "20px"
                   :height "20px"}}})

(defstyled naked-button-text-s :div
  {})

(defstyled select-s :select
  {:border-radius 0
   :border-width "1px"
   :border-style "solid"
   :border-color (with-meta #(or % vars/border-light) :border-color)
   :background "white"
   :color vars/gray
   :cursor "pointer"
   :font-size "1rem"
   :height "3rem"
   :padding (with-meta #(if % "12px 1rem 0" "0 1rem") :label?)
   :width (with-meta #(or % "100%") :width)
   :max-width (with-meta #(or % "100%") :max-width)
   :-webkit-appearance "none"
   :transition "border .25s ease-in"
   :&:focus {:outline (str "1px dotted " (get-theme :primary))
             :outline-offset "2px"
             :border-color (get-theme :primary)}
   ::cljss/media {[[:max-width "768px"]]
                  {:height "4rem"
                   :display "flex"
                   :align-items "center"
                   :max-width "100%"}}})

(defstyled select-container-s :div
  {:position "relative"
   :max-width (with-meta #(or % "330px") :max-width)
   ::cljss/media {[[:max-width "768px"]]
                  {:max-width "100%"}}})

(defstyled select-i-s :i
  {:font-size "0.87rem"
   :position "absolute"
   :pointer-events "none"
   :right "1rem"
   :top "0"
   :bottom "0"
   :margin "auto"
   :display "flex"
   :height "5px"})

(defn select [{:keys [max-width]}]
  (let [this (r/current-component)]
    [select-container-s {:max-width max-width}
     (into [select-s (r/props this)] (r/children this))
     [select-i-s [icon/chevron]]]))

(defstyled label :label
  {:color vars/gray
   :margin-bottom "0.66rem"})

(defstyled input-row-s :div
  {:position "relative"
   :margin (with-meta #(or % "0 0 2rem") :margin)
   :grid-column (with-meta #(or % "auto") :grid-column)
   :grid-template-columns (with-meta #(if % % "auto") :grid-template-columns)
   :display (with-meta #(if % "grid" "block") :grid-template-columns)
   :&:before {:content "$"
              :position "absolute"
              :display (with-meta #(if % "block" "none") :currency?)
              :color vars/gray
              :left "10px"
              :top "23px"}
   :&:after {:content "%"
             :position "absolute"
             :display (with-meta #(if % "block" "none") :percent?)
             :color vars/gray
             :left "3.5rem"
             :top "23px"}})

(defstyled input-label-s :label
  {:position (with-meta #(if % "static" "absolute") :above?)
   :pointer-events "none"
   :color (with-meta #(if % vars/gray "#bdbdbd") :above?)
   :font-size (with-meta #(if % "1rem" ".7333rem") :above?)
   :margin (with-meta #(if % "0 0 1rem" "0") :above?)
   :line-height (with-meta #(if % "1.56rem" "normal") :above?)
   :display "block"
   :z-index "1"
   :top "6px"
   :left ".6rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:top "8px"}}})

(defstyled input :input
  {:background "white"
   :border-radius 0
   :border (str "1px solid " vars/border-light)
   :color vars/gray
   :font-size (with-meta #(or % "1rem") :font-size)
   :cursor "text"
   :height "3rem"
   :width "100%"
   :max-width (with-meta #(or % "22rem") :max-width)
   :margin (with-meta #(or % "0") :margin)
   :padding "0 .5rem"
   :padding-top (with-meta #(if (true? %) ".8rem" "0") :label?)
   :padding-left (with-meta #(if % "1.5rem" ".5rem") :unit?)
   :-webkit-appearance "none"
   :transition "border .25s ease-in"
   :&:focus {:border-color (get-theme :primary)
             :outline (str "1px dotted " (get-theme :primary))
             :outline-offset "2px"}
   ::cljss/media {[[:max-width "768px"]]
                  {:height "4rem"
                   :display "flex"
                   :align-items "center"
                   :max-width "100%"}}})

(defstyled textarea-s :textarea
  {:color vars/gray
   :width "100%"
   :border (str "1px solid " vars/border-light)
   :min-height "8rem"
   :padding (with-meta #(if % "1.2rem .5rem" ".5rem") :label?)
   :&:focus {:border-color (get-theme :primary)
             :outline (str "1px dotted " (get-theme :primary))
             :outline-offset "2px"}})

(defstyled checkbox-wrapper-s :div
  {})

(defstyled checkbox-label-s :label
  {:cursor "pointer"
   :position "relative"
   :padding-left "2.5rem"
   :display "flex"
   :height "1.33rem"
   :line-height "1.33rem"
   :align-items "center"
   :transition "color 0.25s ease-in"
   :&:hover {:color (get-theme :primary)}
   :&:before {:position "absolute"
              :left "0"
              :top "0"
              :width "1.33rem"
              :height "1.33rem"
              :border (str "2px solid " (get-theme :primary))
              :display "block"
              :content ""}

   :&:after {:opacity (with-meta #(if % "1" "0") :checked?)
             :content "✓"
             :color (get-theme :primary)
             :font-size "1.75rem"
             :font-weight "300"
             :transition "opacity 0.25s ease-in"
             :display "block"
             :position "absolute"
             :left ".1rem"
             :top ".05"}})

(defstyled checkbox-s :input
  {:display "none"})

(defn- today []
  (to-input-date (now)))

(defn future-date
  ([props] (future-date input props))
  ([element props]
   [element (merge {:min (today)
                    :max "9999-12-31"
                    :type "date"} props)]))

(defn past-date
  ([props] (past-date input props))
  ([element props]
   [element (merge {:max (today)
                    :min "1900-01-01"
                    :type "date"} props)]))
